import React, { Component } from 'react'

class Post extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            postLoaded: false
        };
        this.post = null;
        this.image = null;
        this.imageAlt = null;
        this.authorsList = false;
        this.categoriesList = false;
        this.abortController = new window.AbortController();
    }
    componentDidMount(){
        this.getPost();
    }
    componentWillUnmount(){
        this.abortController.abort();
    }
    getPost(){
        const { id, type } = this.props.data;
        if(id && type){
            fetch( window.wpApiSettings.root + `wp/v2/${type}/${id}/?_embed`, { signal: this.abortController.signal } )
            .then( response => response.json() )
            .then( post => {
                this.post = post;
                // Author
                this.authorsList = post._embedded.author;
                // Featured Media
                if( 0 !== post.featured_media ){
                    if( undefined !== post._embedded['wp:featuredmedia'][0].media_details.sizes.large ){
                        this.image = post._embedded['wp:featuredmedia'][0].media_details.sizes.large.source_url;
                    }else{
                        this.image = post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url;
                    }
                    this.imageAlt = post._embedded['wp:featuredmedia'][0].alt_text;
                }
                // Categories
                if( undefined !== post.categories ){
                    this.categoriesList = post._embedded['wp:term'];
                }
                this.setState( { postLoaded: true } );
            })
            .catch( error => {
                if (error.name === 'AbortError') return; // expected, this is the abort, so just return
                throw error; // must be some other error, handle however you normally would
            })
        }
    }
    renderPostAuthor(){
        const postAuthorsList = [];
        for ( const i in this.authorsList){
            postAuthorsList.push( this.authorsList[i].name );
        }
        return <span>{window.nlfL10n.By} {postAuthorsList.join(', ')}</span>;
    }
    renderPostCategories(){
        const postCategoriesList = [];
        for ( const i in this.categoriesList[0]){
            if( 'category' === this.categoriesList[0][i].taxonomy  ){
                postCategoriesList.push( this.categoriesList[0][i].name );
            }
        }
        return <span>{window.nlfL10n.In} {postCategoriesList.join(', ')}</span>;
    }
        
    render() {
        const {postLoaded} = this.state;
        if( postLoaded ){
            return (
                <div className="nlf-viewer-block nlf-viewer-post news">
                        <div className="nlf-block-content">
                            <div className="nlf-block-content-post post-item">
                                {this.image && this.props.data['showImage'] && <a href={this.post.link} title={this.post.title.rendered} className="image"><img className="nlf-block-content-post-image attachment-blog size-blog wp-post-image" src={this.image} alt={this.imageAlt} /></a>}
                                <h2 className="nlf-block-content-post-title post-item__title post-item__title--abs">{this.post.title.rendered}</h2>
                                { (this.props.data['showCategory'] || this.props.data['showAuthor']) && <div className="nlf-block-content-post-metas">
                                    <em>
                                    {this.categoriesList.length > 0 && this.props.data['showCategory'] && this.renderPostCategories()}
                                    {this.authorsList && this.props.data['showAuthor'] && this.renderPostAuthor()}
                                    </em>
                                </div>}
                                <div className="nlf-block-content-post-excerpt post-excerpt" dangerouslySetInnerHTML={ { __html: this.post.excerpt.rendered } }></div>
                                <a href={this.post.link} title={this.post.title.rendered} className="nlf-button nlf-block-content-post-actions-button btn btn-default"><span>{window.nlfL10n.ReadOn}</span></a>
                            </div>
                        </div>
                </div>
            );
        }
        return '';
    }
}

export default Post


// WEBPACK FOOTER //
// ./src/Post.js